<template>
  <div class="production_wrap">
    <div class="production_img" id="cpjz">
      <div class="production_img_inner">
        <div class="img_desc">良悦高级计划排程系统APS解决方案</div>
        <div class="img_tit">高效实现生产计划滚动排产，降本增效</div>
<!--        <div class="img_desc">从设计到交付，数字化全链贯通，一站式数字化制造服务，让效率与质量双擎驱动</div>-->
        <router-link class="img_btn" to="/Experience">立即咨询</router-link>
      </div>

    </div>
    <div class="tab-area hidden-xs-only">
      <div class="tab-area-bg"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="系统定位" name="first"></el-tab-pane>
        <el-tab-pane label="业务流程" name="second"></el-tab-pane>
        <el-tab-pane label="核心功能" name="third"></el-tab-pane>
        <el-tab-pane label="业务场景" name="seven"></el-tab-pane>
        <el-tab-pane label="设备支持" name="fourth"></el-tab-pane>
        <el-tab-pane label="关联模块" name="five"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="service-card" >
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">系统定位</div>
          <div class="production_desc hidden-xs-only">智能制造的核心决策引擎</div>
          <div class="production_desc hidden-xs-only">是面向制造业的智能化生产调度平台，通过算法优化与实时数据驱动，实现从订单到交付的全链路资源动态调配</div>
          <div class="production_desc hidden-sm-and-up">面向制造业的智能化生产调度平台</div>
        </div>
      </div>

      <div class="production_box" >
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/zyzhq.png"/>
            <div>生产优化中枢</div>
            <div class="content">解决多品种、小批量、短交期的复杂排产难题，提升设备利用率与订单交付准时率</div>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/znjc.png"/>
            <div>资源调度大脑</div>
            <div class="content">动态平衡设备、人力、物料等资源，规避瓶颈并降低库存成本</div>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/mjxy.png"/>
            <div>敏捷响应枢纽</div>
            <div class="content">支持插单、设备故障等突发事件的快速重排，缩短响应时间至分钟级</div>
          </div>
        </div>
        <div class="production_item" id="cptd">
          <div class="title">
            <img  src="../../assets/img/solution/cxjs.png"/>
            <div>战略决策支撑</div>
            <div class="content">结合AI预测与数字孪生技术，为产能规划、供应链协同提供数据依据</div>
          </div>
        </div>
      </div>
</div>

    <div class="tedian">
      <div class="production_title_wrap flow-title">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title" >良悦APS解决方案业务流程</div>
          </div>
        </div>
      </div>
      <div class="title_card"><img src="../../assets/img/solution/APS_title.svg"/></div>
      <div class="production_card">
        <img src="../../assets/img/solution/APS.svg" class="gaizao"/>
      </div>
    </div>

      <div class="hexin-area" >
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title"  id="fwfc">核心功能</div>
          </div>
        </div>
        <div class="production_card hidden-sm-and-up">
          <el-row class="card_wrap " type="flex" >
            <el-col
                class="brain_item"
                :lg="7"
                :sm="11"
                :xs="24"
                v-for="(item, index) in cardList"
                :key="index"
            >
              <div class="item_bg hidden-xs-only"></div>
              <el-row style="z-index: 2">
                <el-col :span="24" :xs="6">
                  <img :src="item.src" alt="" class="img_item"/>
                </el-col>
                <el-col :span="24" :xs="18" class="con">
                  <div class="item_title">{{ item.title }}</div>
                  <div class="item_desc">{{ item.desc1 }}</div>
                  <div class="item_desc">{{ item.desc2 }}</div>
                </el-col>
              </el-row>

              <!--        <div class="item_title">{{ item.title }}</div>-->
              <!--        <div class="item_desc">{{ item.desc }}</div>-->
              <!--        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>-->
              <!--        <div class="item_bg"></div>-->
            </el-col>
          </el-row>
        </div>
        <div class="production_card wms-hx hidden-xs-only">
          <img src="../../assets/img/solution/aps-hx-line.svg" class="line-img"/>
          <div class="aps-hx-row">
            <div class="aps-hx-col" @mouseover="zyyhpz=true" @mouseleave="zyyhpz=false">
              <img src="../../assets/img/solution/aps-hx/zyyhpz-w.svg" v-if="zyyhpz" class="aps-hx-img">
              <img src="../../assets/img/solution/aps-hx/zyyhpz.svg" v-else class="aps-hx-img">
              <div class="aps-hx-title">资源优化配置</div>
              <div class="aps-hx-desc">瓶颈识别：自动标记超负荷设备，推荐外协或班次调整方案</div>
              <div class="aps-hx-desc">齐套检查：联动BOM与库存数据，预警物料短缺风险</div>
            </div>
            <div class="aps-hx-col" @mouseover="gjjhpc=true" @mouseleave="gjjhpc=false">
              <img src="../../assets/img/solution/aps-hx/gjjhpc-w.svg" v-if="gjjhpc" class="aps-hx-img">
              <img src="../../assets/img/solution/aps-hx/gjjhpc.svg" v-else class="aps-hx-img">
              <div class="aps-hx-title">高级计划排程</div>
              <div class="aps-hx-desc">支持离散/流程制造模式，兼容混线生产与定制化订单；可视化甘特图展示排产结果，支持拖拽式人工干预</div>
            </div>
            <div class="aps-hx-col" @mouseover="dtddyq=true" @mouseleave="dtddyq=false">
              <img src="../../assets/img/solution/aps-hx/dtddyq-w.svg" v-if="dtddyq" class="aps-hx-img">
              <img src="../../assets/img/solution/aps-hx/dtddyq.svg" v-else class="aps-hx-img">
              <div class="aps-hx-title">动态调度引擎</div>
              <div class="aps-hx-desc">插单响应：30分钟内完成计划重排并评估交期影响</div>
              <div class="aps-hx-desc">换线优化：基于模具切换时间最小化原则排序生产批次</div>
            </div>
            <div class="aps-hx-col" @mouseover="gylxt=true" @mouseleave="gylxt=false">
              <img src="../../assets/img/solution/aps-hx/gylxt-w.svg" v-if="gylxt" class="aps-hx-img">
              <img src="../../assets/img/solution/aps-hx/gylxt.svg" v-else class="aps-hx-img">
              <div class="aps-hx-title">供应链协同</div>
              <div class="aps-hx-desc">供应商联动：共享排产计划指导原材料准时到货</div>
              <div class="aps-hx-desc">客户透明化：提供订单进度实时追踪接口</div>
            </div>
            <div class="aps-hx-col" @mouseover="aizq=true" @mouseleave="aizq=false">
              <img src="../../assets/img/solution/aps-hx/aizq-w.svg" v-if="aizq" class="aps-hx-img">
              <img src="../../assets/img/solution/aps-hx/aizq.svg" v-else class="aps-hx-img">
              <div class="aps-hx-title">AI增强模块</div>
              <div class="aps-hx-desc">需求预测：LSTM算法预测未来3个月订单波动</div>
              <div class="aps-hx-desc">预防性维护：设备传感器数据触发保养计划调整</div>
            </div>
          </div>
        </div>
      </div>
    <span id="ywcj"></span>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">APS系统业务场景关系</div>
        </div>
      </div>
      <div class="production_card">
        <el-row>
          <el-col :span="14" :xs="24" class="yw-img-col"><img src="../../assets/img/solution/APS_scenario.svg" class="yw-img"/></el-col>
          <el-col :span="2"  class="hidden-xs-only">&nbsp;</el-col>
          <el-col :span="8" :xs="24" class="yw-text-col">
            <el-row class="yw-text-row">
              <el-col :span="5"><img src="../../assets/img/solution/yw-1.svg" class="aps-yw-img"/></el-col>
              <el-col :span="19" class="aps-yw-col">
                <div class="aps-yw-title">强大的可视化能力</div>
                <div class="aps-yw-desc">支持多地多工厂的需求，容量和库存可见性</div>
              </el-col>
            </el-row>
            <el-row class="yw-text-row">
              <el-col :span="5"><img src="../../assets/img/solution/yw-2.svg" class="aps-yw-img"/></el-col>
              <el-col :span="19" class="aps-yw-col">
                <div class="aps-yw-title">强大的系统集成能力</div>
                <div class="aps-yw-desc">支持多种ERP和MES平台提供商集成</div>
              </el-col>
            </el-row>
            <el-row class="yw-text-row">
              <el-col :span="5"><img src="../../assets/img/solution/yw-3.svg" class="aps-yw-img"/></el-col>
              <el-col :span="19" class="aps-yw-col">
                <div class="aps-yw-title">强大的约束配置能力</div>
                <div class="aps-yw-desc">支持更多样化的组合优化，给出合理排程方案</div>
              </el-col>
            </el-row>
            <el-row class="yw-text-row">
              <el-col :span="5"><img src="../../assets/img/solution/yw-4.svg" class="aps-yw-img"/></el-col>
              <el-col :span="19" class="aps-yw-col">
                <div class="aps-yw-title">强大的排程方案评价能力</div>
                <div class="aps-yw-desc">支持假设场景下的多排程方案KPI指标评价与成本分析</div>
              </el-col>
            </el-row>

          </el-col>
        </el-row>

      </div>
    </div>
    <span id="gzfx"></span>
    <div class="tedian1"  >
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title">设备支持</div>
          </div>
        </div>
      </div>
      <div class="production_card">
        <el-row class="row-area" id="glmk">
          <el-col :span="4" :xs="24" class="col-area">
            <div class="first-btn">多终端适配</div>
          </el-col>
          <el-col :span="1" class="hidden-xs-only">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/pc.svg" />PC端
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/app.svg" />手机APP
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/pad.svg" />平板
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="6" class="col-area">
            <img src="../../assets/img/solution/pda.svg" />工业PDA
          </el-col>
        </el-row>
        <el-row class="row-area">
          <el-col :span="4" :xs="24" class="col-area">
            <div class="first-btn">数据中心适配</div>
          </el-col>
          <el-col :span="1" class="hidden-xs-only">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/crh.svg" />超融合
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/xnh.svg" />虚拟化
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/syy.svg" />私有云
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="6" class="col-area">
            <img src="../../assets/img/solution/ctit.svg" />传统IT架构
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">关联模块</div>
        </div>
      </div>
      <div class="production_card">
      <el-row :gutter="20" class="guanlian-row-area">
        <el-col :span="8" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl1.jpg" class="image">
            <span class="guanli-title">纵向关联</span>
            <div class="guanli-area">
              <span>制造执行系统MES</span>
              <div class="time">下发工序级任务指令，回收在制品状态信息</div>
              <span>企业资源管理系统ERP</span>
              <div class="time">接收销售订单与BOM数据，反馈实际生产成本</div>

            </div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl2.jpg" class="image">
            <span class="guanli-title">横向扩展</span>
            <div class="guanli-area">
              <span>供应链管理系统SCM</span>
              <div class="time">供应商交货能力数据优化原材料采购计划</div>
              <span>客户管理系统CRM</span>
              <div class="time">客户需求波动数据指导产能预留策略</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl3.jpg" class="image">
            <span class="guanli-title">底层数据互通</span>
            <div class="guanli-area">
              <span>数字孪生</span>
              <div class="time">虚拟工厂模拟排产方案可行性</div>
              <span>大数据分析</span>
              <div class="time">历史排产数据挖掘优化规则库</div>

            </div>
          </el-card>
        </el-col>
<!--        <el-col :span="8">-->
<!--          <el-card :body-style="{ padding: '0px' }">-->
<!--            <img src="../../assets/img/solution/gl3.jpg" class="image">-->
<!--            <div class="guanli-area">-->
<!--              <span>AI与大数据</span>-->
<!--              <div class="time">分析历史数据预测故障，生成智能优化建议</div>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->
      </el-row>
      </div>
    </div>
    <div class="tedian1 padding80" >
      <Zixun />
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
// import ProCard from './ProCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
export default {
  data() {
    return {
      activeName:"first",
      currentSub:"",
      zyyhpz:false,
      gjjhpc:false,
      dtddyq:false,
      gylxt:false,
      aizq:false,
      cardList:[
        {
          title:"资源优化配置",
          src: require('@/assets/img/solution/aps-hx/zyyhpz.svg'),
          desc1:"瓶颈识别：自动标记超负荷设备，推荐外协或班次调整方案；",
          desc2:"齐套检查：联动BOM与库存数据，预警物料短缺风险"
        },{
          title:"高级计划排程",
          src: require('@/assets/img/solution/aps-hx/gjjhpc.svg'),
          desc1:"支持离散/流程制造模式，兼容混线生产与定制化订单；",
          desc2:"可视化甘特图展示排产结果，支持拖拽式人工干预"
        },{
          title:"动态调度引擎",
          src: require('@/assets/img/solution/aps-hx/dtddyq.svg'),
          desc1:"插单响应：30分钟内完成计划重排并评估交期影响；",
          desc2:"换线优化：基于模具切换时间最小化原则排序生产批次"
        },{
          title:"供应链协同",
          src: require('@/assets/img/solution/aps-hx/gylxt.svg'),
          desc1:"供应商联动：共享排产计划指导原材料准时到货；",
          desc2:"客户透明化：提供订单进度实时追踪接口"
        },{
          title:"AI增强模块",
          src: require('@/assets/img/solution/aps-hx/aizq.svg'),
          desc1:"需求预测：LSTM算法预测未来3个月订单波动；",
          desc2:"预防性维护：设备传感器数据触发保养计划调整"
        }
      ]
    }
  },
  components: {
    Zixun,
    CallMe,
    MobileCallme,
  },
  mounted() {
    this.activeName="first"
    let elements = document.querySelectorAll('.tab-area');
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 420){
        elements.forEach(function(element) {
          element.classList.add('tab-area-fixed');
        });
        if(document.documentElement.scrollTop > 700){
          this.activeName="second"
        }
        if(document.documentElement.scrollTop > 1400){
          this.activeName="third"
        }
        if(document.documentElement.scrollTop > 2200){
          this.activeName="seven"
        }
        if(document.documentElement.scrollTop > 2800){
          this.activeName="fourth"
        }
        if(document.documentElement.scrollTop > 3500){
          this.activeName="five"
        }
      }else {
        this.activeName="first"
        elements.forEach(function (element) {
          element.classList.remove('tab-area-fixed');
        });
      }
    }
  },
  methods:{
    overSub(flag){
      this.currentSub = flag
    },
    outSub(){
      this.currentSub = ''
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('cpjz');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="second"){
        const element = document.getElementById('cptd');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="third"){
        const element = document.getElementById('fwfc');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="seven"){
        const element = document.getElementById('ywcj');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="fourth"){
        const element = document.getElementById('gzfx');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="five"){
        const element = document.getElementById('glmk');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flow-title{
  padding-bottom: 0 !important;
}
.tedian1 {
  background-color: rgba(245, 247, 250, 1);
  padding: 5px 0 5px 0;
}
.tedian{
  background-color:#EDF5FF;
  padding: 5px 0 5px 0 ;
  .title_card{
    width: 70%;
    margin: 40px auto 0 auto;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    img{
      width: 100%;
      margin-bottom: 0;
    }
  }
  .production_card{
    margin-top: 20px !important;
  }

}
.hexin-area{
  background: url('../../assets/img/solution/wms-hx-bg.jpg') 0 0 no-repeat;
  background-size: 100% 100%;
  //height: 600px;
  padding-top: 30px;
  @media screen and (max-width: 768px) {
    padding-top: 20PX;
    background: rgba(245, 247, 250, 1);
  }
}
.production_wrap {
  width: 100%;
  margin-top: 70px;
  .production_img {
    background: url('../../assets/img/solution/aps-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 768px) {
      background-size: cover ;
      background-position: 50% 100%;
    }
  }
  .wms-hx{
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    .line-img{
      height: 500px;
    }
  }
  .aps-hx-row{
    display: flex;
    justify-content:space-evenly;
    margin-top: -120px;
    .aps-hx-col{
      width: calc(100% / 5 - 20px); /* 减去间距 */;
      text-align: center;
      background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);

      border: 2px solid #FFFFFF;
      border-radius: 8px;
      box-shadow: 5px 5px 12px 2px rgb(12 28 56 / 18%);
      padding: 20px;
      &:hover{
        background: #00A4FF;
        border: 2px solid #00A4FF;
        .aps-hx-title{
          color: #fff;
        }
        .aps-hx-desc{
          color: #fff;
        }
      }
      .aps-hx-title{
        font-size: 18px;
        font-weight: bold;
        color: #253554;
        margin-bottom: 5px;
      }
      .aps-hx-desc{
        text-align: left;
        font-size: 13px;
        color: #808080;
      }
    }
    .aps-hx-img{
      width: 80px;
      margin-bottom: 10px;
    }
  }
  .aps-yw-title{
    font-size: 18px;
    font-weight: bold;
    color: #253554;
    margin-bottom: 5px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      line-height: 1.8rem;
    }
  }
  .aps-yw-col{
    margin-bottom: 60px;
  }
  .aps-yw-desc{
    text-align: left;
    font-size: 13px;
    color: #808080;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
  .yw-text-col{
    padding-top: 80px;
  }
  .yw-text-row{
    @media screen and (max-width: 768px) {
      margin-bottom: 10PX;
    }
  }
  .yw-img-col{
    text-align: center;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
    .yw-img{
      height: 550px;
      @media screen and (max-width: 768px) {
        width: 95%;
        height: auto;
      }
    }
  }

  .aps-yw-img{
    width: 48px;
    float: right;
    margin-right: 6px;
    margin-top: 3px;
    @media screen and (max-width: 768px) {
      width: 40PX;
      margin-right: 10PX;
      margin-top: 6PX;
    }
  }
  .last-item-bottom{
    margin-bottom: -50px;
  }
  .production_title_wrap {
    width: 100%;
    margin-top: 50px;
    //padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
  }

  .bottom{
    width: 60%;
    margin: auto;
    text-align: center;
    margin-top: -80px;
    color: rgba(37, 53, 84, 0.5);
    font-size: 14px;
  }
  .production_box {
    margin: auto;
    width: 70%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      width: 95%;
      justify-content: space-around;
      flex-wrap: wrap;
      margin-top: 10PX;
      margin-bottom: 30PX;
    }
    .bg{
      width: 100%;
      border-radius: 4px;
    }
    .production_item {
      width: calc(100% / 4 - 12px); /* 减去间距 */
      margin: 8px 6px; /* 可根据需要调整 */
      padding-right: 40px;
      display: flex;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-left: 0;
        margin-top: 10PX;
        box-shadow: 2px 2px 5px 2px rgba(12, 28, 56, 0.05);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        padding: 20px 10px;
        border: 1px solid rgba(224, 236, 255, 1);

      }
      .title{
        width: 100%;
        font-size: 24px;
        color: rgba(37, 53, 84, 1);
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          line-height: 1.5rem;
          font-weight: bold;
        }
        img{
          margin-bottom: 10px;
          width: 60px;
          @media screen and (max-width: 768px) {
            width:40PX;
            float: left;
            margin-right: 15PX;
          }
        }
        .content{
          margin-top: 10px;
          font-size: 14px;
          line-height: 24px;
          color: rgba(37, 53, 84, 0.6);
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
            line-height: 1.2rem;
            margin-left: 55PX;
            font-weight: normal;
          }
        }
      }
    }
  }
  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .service-card {
    width: 100%;
    margin: 50px auto;
    background-color: #fff;
  }
  .production_card {

    width: 70%;
    margin: 50px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 20PX auto;
    }

    .title-div{
      img{
        float: left;
        height: 30px;
        width: 1px;
        margin-top: 5px;
      }
      .title{
        float: left;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
        color: #05102F;
        padding-right: 15px;
      }
      .desc{
        float: left;
        font-size: 22px;
        line-height: 40px;
        color: #808080;
        padding-left: 15px;
      }
    }
    .item-content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .sub-item-yzs{
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #E0ECFF;
        padding: 10px;
        box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.1);
        width: calc(100% / 5 - 10px); /* 减去间距 */
        margin-right: 20px;
        .down-card{
          width: 100%;
          padding: 0 8px 0px 8px;
          color: #808080;
          line-height: 26px;
          font-size: 13px;
        }
        .up-card{
          display: flex;
          line-height: 60px;
          font-size: 22px;
          color: #16181A;
          font-weight: bold;
          img{
            width: 28%;
            margin-right: 5px;
          }
        }
        &:hover{
          box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.2);
          .up-card{
            color: #0052D9;
          }
        }
      }

    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.basic-area{
  margin: auto;width: 70%;
  padding: 0 14px 30px 14px;

  .title{
    border-radius: 8px;color: #fff;
    background: #3393FD;
    line-height: 40px;
    text-align: center;
  }
  .content{
    border-radius: 8px;
    background: linear-gradient(180deg, #F6F8FF 0%, #D9E6FA 100%);
    border: 2px dashed #a3c4fe;
    width: 100%;
    margin-top: 10px;
    padding: 15px 8px;
    display: flex;
    .content-item{
      padding: 20px;
      text-align: center;
      margin: 0 1%;
      //float: left;
      width: 9%;
      border: 2px dashed #a3c4fe;
      background-color: #FBFDFF;
      border-radius: 8px;
      align-content: center;
      color: #05102F;
    }

  }
}
.production_core_scene{
  background-color: #F5F7FA;
  width: 70%;
  margin: 30px auto;
  padding: 30px 50px 20px 50px;
  height: 350px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(2, 99, 255, 1) 41.2%, rgba(131, 181, 254, 1) 100%);
  .production_core_scene_title{
    align-content: center;
    color: #fff;
    letter-spacing: 2px;
    padding-bottom: 20px;
    .sub1{
      font-size: 32px;
      margin-right: 10px;
      font-weight: bold;
      line-height: 40px;
      float: left;
    }
    img{
      float: left;
      height: 30px;
      margin-top: 5px;
      width: 1px;
    }
    .sub2{
      margin-left: 10px;
      font-size: 20px;
      line-height: 40px;
      float: left;
    }
  }
  .item-bg{
    float: left;
    width: 24%;
    img{
      width: 90%;
    }
  }
  .item{
    float: left;
    width: 16%;
    padding: 0 20px;
    margin-left: 3%;
    text-align: center;
    border-radius: 4px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39.8%, rgba(255, 255, 255, 0.8) 64.35%, rgba(255, 255, 255, 0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 230px;
    font-size: 12px;
    color: #8491AB;
    .bg{
      width: 46%;
    }
    .hx{
      margin: 10px 0;
      width: 100%;
    }
    .btn-area{
      width: 100%;
    }
    .left-div{
      flex: 1;
      width: 48%;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
      margin-right: 2%;
    }
    .right-div{
      width: 48%;
      flex: 1;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
    }
    span{
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: #253554;
    }
  }

}
.tab-area{
  margin: auto;
  width: 100%;
  .tabs{
    margin: 0 15%;
    margin-top: -50px;
  }
  .tab-area-bg{
    background: #FFFFFF;
    height: 60px;
    box-shadow: 0 4px 12px rgba(12, 28, 56, 0.2);
  }
}
.tab-area-fixed{
  position: fixed;
  top: 70px;
  z-index: 999;
}
::v-deep(.el-tabs__nav-wrap::after){
  background-color: #fff !important;
}
::v-deep(.el-tabs__item ){
  margin-bottom: 10px;
}
::v-deep(.el-tabs__item.is-active ){
  color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: #0052D9  !important;
  height: 3px;
}
.shenru-btn {
  width: 180px;
  height: 40px;
  background: #0052D9;
  color: #fff;
  bottom: 15%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s;
  margin: 30px auto 10px auto;
  &:hover {
    color: #fff;
    font-weight: bold;
    background: #24b1ff;
  }
  @media screen and (max-width: 768px) {
    width: 80px;
    height: 30px;
    font-size: 14px;
  }
}
.gaizao{
  width: 100%;
  margin-bottom: 20px;

}
.padding80{
  padding-top: 80px
}
.card_wrap {
  width: 70%;
  flex-wrap: wrap;
  margin: 0px auto;
  padding-bottom: 20px;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 95%;
  }
  .brain_item {
    transition: background-color 1s;
    padding: 20px 5px;
    border-radius: 4px;
    margin-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
      border-radius: 5PX;
      //justify-content: center;
      align-items: center;
      display: flex;
      margin-bottom: 10PX;
      background: linear-gradient(180deg, rgba(243, 245, 248, 1) 0%, rgba(255, 255, 255, 1) 100%);
      border: 2px solid rgba(255, 255, 255, 1);
      padding: 10PX 20PX 10PX 10PX;
    }
    .img_item {
      margin-top: 18px;
      width: 60% ;
      @media screen and (max-width: 768px) {
        width:70PX;
        height: 70PX;
        margin-top: 18PX;
        margin-right: 5PX;
      }
    }
    &:hover{
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      //background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 4px;
      z-index: 1;
      //border: 1px solid #fff;

    }

    .item_bg_div{
      width:100px;
      height:100px;
      background:linear-gradient(180deg, rgba(237, 241, 252, 1) 0%, rgba(255, 255, 255, 1) 100%);
      box-shadow: 0 0.2rem 1rem 0.2rem rgba(12, 28, 56, 0.08);
      border: 2px solid #fff;
      border-radius: 50%;
      text-align: center;
      margin: auto;
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        width: 70PX;
        height: 70PX;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8PX;
      }
      &:hover{
        box-shadow: 0 0.2rem 1.5rem 0.2rem rgba(12, 28, 56, 0.128);
        border: 1px solid #fff;
      }
    }
    &:hover .item_bg{
      opacity: 1;
    }
    &:hover .item_title {
      color: #0052D9;
    }
    //&:hover .item_desc {
    //  color: #0052D9;
    //}
    .item_title {
      transition: all 0.5s;
      font-size: 18px;
      font-weight: bold;
      color: #253554;
      text-align: center;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        width: 100%;
        font-size: 1rem;
        text-align: left;
        line-height: 1.8rem;
      }
    }
    .item_desc {
      width: 90%;
      transition: all 0.5s;
      color: #808080;
      text-align: left;
      line-height: 24px;
      z-index: 2;
      position: inherit;
      font-size: 13px;
      min-height: 30px;
      margin: auto;
      @media screen and (max-width: 768px) {
        width: 100%;
        font-size: 0.7rem;
        line-height: 1.2rem;
        margin-left: 0;
      }
      i{
        padding-right: 5px;
        color: #19B21E;
        font-weight: bold
      }
    }
    .item_navigate {
      width: 100PX;
      height: 30PX;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        margin-bottom: 10PX;
        font-size: 14px;
      }
    }
  }
}
</style>